import React from 'react';
import AlternatePickSlot from './AlternatePickSlot';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

/**
 * Displays the alternate fighter selections
 * 
 * @param {Object} props
 * @param {Array} props.alternates - Array of alternate fighter objects
 * @param {Function} props.onAddAlternate - Callback to add an alternate fighter
 * @param {Function} props.onRemoveAlternate - Callback to remove an alternate fighter
 * @param {boolean} props.isDisabled - Whether adding alternates is disabled
 * @param {Object} props.eventData - Full event data with fights and fighters
 * @returns {JSX.Element}
 */
const AlternatePicks = ({
  alternates,
  onAddAlternate,
  onRemoveAlternate,
  isDisabled = false,
  eventData
}) => {
  // Helper function to find opponent for a fighter
  const findOpponent = (fighterId) => {
    if (!eventData || !eventData.Fights) return null;
    
    for (const fight of eventData.Fights) {
      if (fight.Fighters && fight.Fighters.length > 1) {
        const fighterIndex = fight.Fighters.findIndex(f => f.FighterId === fighterId);
        if (fighterIndex >= 0) {
          // Return the opponent (if there are 2 fighters, return the other one)
          return fight.Fighters[fighterIndex === 0 ? 1 : 0];
        }
      }
    }
    return null;
  };

  return (
    <div className="space-y-4">
      {/* Alternate slots */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {Array(2).fill(null).map((_, index) => {
          const fighter = alternates[index];
          
          if (fighter) {
            return (
              <AlternatePickSlot
                key={index}
                fighter={fighter}
                opponent={findOpponent(fighter.FighterId)}
                onRemove={onRemoveAlternate}
              />
            );
          }
          
          return (
            <div 
              key={index}
              className="border border-gray-300 hover:border-deep-red transition-colors duration-200 rounded-lg bg-gray-50 h-full flex"
            >
              <button
                onClick={onAddAlternate}
                className="w-full px-3 py-3 flex items-center justify-center gap-2 cursor-pointer hover:bg-gray-100 active:bg-gray-100 text-medium-grey disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isDisabled}
              >
                <div className="w-6 h-6 rounded-full bg-deep-red flex items-center justify-center">
                  <FontAwesomeIcon icon={faPlus} className="text-white text-xs" />
                </div>
                <span className="text-sm font-medium text-dark-grey">
                  {isDisabled ? 
                    'Complete primary lineup first' : 
                    'Add Alternate Fighter'}
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AlternatePicks; 